import React from 'react';

const ENTER_KEY_CODE = 13;

export default class NumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || ''
        };
        this._save = this._save.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onBlur = this._onBlur.bind(this);
    }

    componentDidMount() {
        if (this.props.dp) {
            this.validate = new RegExp(`^\\d*(\\.\\d{0,${this.props.dp}})?$`);
        } else {
            this.validate = new RegExp('^\\d*$');
        }
    }

    setValue(value) {
        this.setState({ value });
    }

    getCurrentValue() {
        return this.state.value;
    }

    _save() {
        this.props.onSave && this.props.onSave(this.state.value);
    }

    _onChange(event) {
        let value = event.target.value;
        if (!this.validate.test(value)) {
            value = this.state.value;
        }
        this.setState({ value });
    }

    _onKeyDown(event) {
        if (event.keyCode === ENTER_KEY_CODE) {
            this._save();
        }
    }

    _onBlur(event) {
        // this._save() TODO
    }

    render() {
        let inputId;
        if (this.props.id) {
            inputId = `${this.props.id}-input`;
        }
        let label;
        if (this.props.label) {
            label = <label htmlFor={inputId}>{this.props.label}</label>;
        }
        return (
            <div className="cc-number-input" id={this.props.id}>
                {label}
                <input
                    type="text"
                    id={inputId}
                    size="5"
                    value={this.state.value}
                    onChange={this._onChange}
                    onKeyDown={this._onKeyDown}
                    onBlur={this._onBlur}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NumberInput.jsx